module.exports={
	"Form": "PhysicalAssetEditManifest",
	"Scope": "PhysicalAsset-Edit",
	"Descriptors":
	{
		"PhysicalAssetDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAsset-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAsset-Edit-Identity",
				"Group": "PhysicalAsset-Edit-Identity"
			}
		},
		"PhysicalAssetDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAsset-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.OriginLatitude":
		{
			"Name": "Origin Latitude",
			"Hash": "PhysicalAsset-Edit-OriginLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.OriginLongitude":
		{
			"Name": "Origin Longitude",
			"Hash": "PhysicalAsset-Edit-OriginLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLatitude":
		{
			"Name": "Bounding Min Latitude",
			"Hash": "PhysicalAsset-Edit-BoundingMinLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLatitude":
		{
			"Name": "Bounding Max Latitude",
			"Hash": "PhysicalAsset-Edit-BoundingMaxLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLongitude":
		{
			"Name": "Bounding Min Longitude",
			"Hash": "PhysicalAsset-Edit-BoundingMinLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLongitude":
		{
			"Name": "Bounding Max Longitude",
			"Hash": "PhysicalAsset-Edit-BoundingMaxLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.IDAssetClassification":
		{
			"Name": "Asset Classification",
			"Hash": "PhysicalAsset-Edit-IDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details",
				"Entity": "AssetClassification",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"PhysicalAssetDetails.IDAssetType":
		{
			"Name": "Asset Type",
			"Hash": "PhysicalAsset-Edit-IDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details",
				"Entity": "AssetType",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"PhysicalAssetDetails.ParentIDPhysicalAsset":
		{
			"Name": "Parent Physical Asset",
			"Hash": "PhysicalAsset-Edit-ParentIDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details",
				"Entity": "PhysicalAsset",
				"SearchFields":
				[
					"Name",
					"Description",
					"AssetNumber"
				]
			}
		},
		"PhysicalAssetDetails.ManifestVersion":
		{
			"Name": "Manifest Version",
			"Hash": "PhysicalAsset-Edit-ManifestVersion",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.AssetNumber":
		{
			"Name": "Asset Number",
			"Hash": "PhysicalAsset-Edit-AssetNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.YearBuilt":
		{
			"Name": "Year Built",
			"Hash": "PhysicalAsset-Edit-YearBuilt",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.IDFIPSState":
		{
			"Name": "FIPSState",
			"Hash": "PhysicalAsset-Edit-IDFIPSState",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details",
				"Entity": "FIPSState",
				"SearchFields":
				[
					"Code",
					"Name"
				]
			}
		},
		"PhysicalAssetDetails.IDFIPSCounty":
		{
			"Name": "FIPSCounty",
			"Hash": "PhysicalAsset-Edit-IDFIPSCounty",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details",
				"Entity": "FIPSCounty",
				"SearchFields":
				[
					"Code",
					"Name"
				]
			}
		},
		"PhysicalAssetDetails.IDPhysicalAsset":
		{
			"Name": "IDPhysical Asset",
			"Hash": "PhysicalAsset-Edit-IDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		},
		"PhysicalAssetDetails.GUIDPhysicalAsset":
		{
			"Name": "GUIDPhysical Asset",
			"Hash": "PhysicalAsset-Edit-GUIDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		},
		"PhysicalAssetDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAsset-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		},
		"PhysicalAssetDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAsset-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		},
		"PhysicalAssetDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAsset-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		},
		"PhysicalAssetDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAsset-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAsset-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAsset-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAsset-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAsset-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAsset-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAsset-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
